module.exports = __webpack_public_path__ + "static/media/39_Welfare_Cell.751081d5.JPG";